import React from 'react';
import { CssVarsProvider, extendTheme } from '@mui/joy';
import { CssVarsProvider as MaterialCss, extendTheme as extendThemeMaterial } from '@mui/material'
import palette from '../assets/palete';

export function ThemeProvider({ children }) {
  const bootstrapTheme = extendTheme({
    colorSchemes: {
      light: { palette },
      dark: { palette },
    },
    fontFamily: {
      body: '"Inter", serif',
      display: '"Inter", serif',
      fallback: '"Inter", serif',
    },
  });

  return <CssVarsProvider theme={bootstrapTheme}>{children}</CssVarsProvider>;
}

export function MaterialThemeProvider({ children }) {
  const base = extendThemeMaterial({})
  const bootstrapTheme = extendTheme({
    ...base,
    colorSchemes: {
      light: { palette },
      dark: { palette },
    },
    fontFamily: {
      body: '"Inter", serif',
      display: '"Inter", serif',
      fallback: '"Inter", serif',
    },
  });

  return <CssVarsProvider theme={bootstrapTheme}>{children}</CssVarsProvider>;
}
